import {
  Component,
  Input,
  QueryList,
  ViewChildren,
  OnInit
} from "@angular/core";
import { FormGroup, FormArray } from "@angular/forms";
import {
  PottingInstructionsFormComponent,
  PottingInstructionsCopyArgs,
  SubstrateDisplay,
  IrrigationDisplay,
  FertigationDisplay,
  PottingInstructionsOptions,
  PotTypeDisplay
} from "./potting-instructions-form/potting-instructions-form.component";
import { CeRequestOptions } from "../../request-header/request-header.component";
import { asEnumerable } from "linq-es2015";

@Component({
  selector: "app-potting-instructions",
  templateUrl: "./potting-instructions.component.html"
})
export class PottingInstructionsComponent implements OnInit {
  @Input() ceRequestOptions: CeRequestOptions;
  @Input() experimentDesignFormGroup: FormGroup;

  public pottingInstructionsOptions: PottingInstructionsOptions;

  constructor() {}

  ngOnInit(): void {
    const potTypes = asEnumerable(this.ceRequestOptions.potTypes)
    .Where(s => s.isActive)
    .OrderBy(s => s.name)
    .Select(s => {
      return <PotTypeDisplay>{
        id: s.id,
        display: s.name
      };
    })
    .ToArray();

    const substrates = asEnumerable(this.ceRequestOptions.substrates)
      .Where(s => s.isActive)
      .OrderBy(s => s.requiresFollowup)
      .ThenBy(s => s.name)
      .Select(s => {
        return <SubstrateDisplay>{
          id: s.id,
          display: s.name
        };
      })
      .ToArray();

    const irrigations = asEnumerable(this.ceRequestOptions.irrigations)
      .Where(s => s.isActive)
      .OrderBy(s => s.requiresFollowup)
      .ThenBy(s => s.name)
      .Select(s => {
        return <IrrigationDisplay>{
          id: s.id,
          display: s.name
        };
      })
      .ToArray();

    const fertigations = asEnumerable(this.ceRequestOptions.fertigations)
      .Where(s => s.isActive)
      .OrderBy(s => s.requiresFollowup)
      .ThenBy(s => s.name)
      .Select(s => {
        return <FertigationDisplay>{
          id: s.id,
          display: s.name
        };
      })
      .ToArray();

    this.pottingInstructionsOptions = {
      potTypes: potTypes,
      substrates: substrates,
      irrigations: irrigations,
      fertigations: fertigations
    };
  }

  public get treatments(): FormArray {
    return <FormArray>this.experimentDesignFormGroup.get("treatments");
  }

  @ViewChildren(PottingInstructionsFormComponent)
  public pottingInstructionForms: QueryList<PottingInstructionsFormComponent>;

  public applyAll(sourceComponent: PottingInstructionsFormComponent): void {
    const args: PottingInstructionsCopyArgs = {
      potType: sourceComponent.potType,
      substrate: sourceComponent.substrate,
      irrigation: sourceComponent.irrigation,
      fertigation: sourceComponent.fertigation
    };

    this.pottingInstructionForms.forEach(f => f.copyValueFrom(args));
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/potting-instructions/potting-instructions.component.ts